import { ADD_LEADERBOARD } from "../constants/leaderboardConstants";

export const addLeaderboard = leaderboard => ({
  type: ADD_LEADERBOARD,
  payload: leaderboard
});
